/**
 * Easier api calls
 */
// Seperate api domain in development. Server is unified when running in production

import type { WebRequestPayload } from '@repo/types/web-requests'

type QuoteRequestPayload = Extract<WebRequestPayload, { eventType: 'QUOTE' }>
type ServiceReportRequestPayload = Extract<WebRequestPayload, { eventType: 'SERVICE_REPORT' }>
type EnquiryRequestPayload = Extract<WebRequestPayload, { eventType: 'ENQUIRY' }>

let apiDomain = ''
if (import.meta.env.DEV) {
  apiDomain = import.meta.env.VITE_API_DOMAIN
}
if (import.meta.env.SSR) {
  apiDomain = import.meta.env.VITE_SERVER_API_DOMAIN
}

const url = `${apiDomain}/api/forms/getquote`
const enqUrl = `${apiDomain}/api/enquiries/send`
const reportUrl = `${apiDomain}/api/report`
const quoteUrl = `${apiDomain}/api/quote`
const urls = {
  enquiry: ' https://nkt2mdk4gi.execute-api.eu-west-2.amazonaws.com/v1/enquiry/general',
  quote: quoteUrl,
  report: reportUrl,
}

async function postData(url = '', data = {}, headers = {}) {
  const response = await fetch(url, {
    method: 'POST',
    headers,
    body: JSON.stringify(data),
  })

  return response.json()
}

export default {
  // async verifyInvisiCaptcha(response: unknown) {
  //   return postData(`${domain}/api/invisicaptcha`, {
  //     params: { response: response },
  //   })
  // },
  // async verifyCaptchaV3(response: unknown) {
  //   return postData(`${domain}/api/captcha`, {
  //     params: { response: response },
  //   })
  // },
  async submitQuote(data: QuoteRequestPayload) {
    return postData(quoteUrl, data, {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    })
  },
  async submitServiceReport(data: ServiceReportRequestPayload) {
    return postData(reportUrl, data, {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    })
  },
  async submitEnquiry(data: EnquiryRequestPayload) {
    return postData(enqUrl, data, {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    })
  },
  submitUniForm(endpoint: keyof typeof urls, data: WebRequestPayload) {
    const url = urls[endpoint]
    const headers = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'x-api-key': 'C1idIcmVAG5HPNnsqIcpx8Ct0qmBjAE3xkzy1K9a',
    }

    return postData(url, data, headers).then((body) => {
      return body
    })
  },
}
